var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVru(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_516",
    "data-name": "Group 516",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 235,
    height: 59.803,
    viewBox: "0 0 235 59.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    width: 235,
    height: 59.803,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M166.854,63.246,160.228,47.24h3.37l4.8,12.409L173.23,47.24H176.6l-6.625,16.006Z",
    transform: "translate(-99.157 -29.235)",
    fill: "#d10a10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M208.016,68.163a4.683,4.683,0,0,0,3.005-1.047l1.776,1.753a7,7,0,0,1-4.827,1.821c-3.87,0-6.17-2.413-6.17-5.988a5.617,5.617,0,0,1,5.965-5.875c3.438,0,5.715,1.981,5.715,5.9,0,.342-.022.683-.045,1.047H204.67c.182,1.389,1.366,2.391,3.347,2.391m-.16-6.876a3.023,3.023,0,0,0-3.141,2.186h6.056c-.182-1.457-1.3-2.186-2.914-2.186",
    transform: "translate(-124.884 -36.405)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M239.216,47.061a1.616,1.616,0,1,1-1.639,1.616,1.569,1.569,0,0,1,1.639-1.616m1.389,16.006h-2.777V51.8h2.777Z",
    transform: "translate(-147.024 -29.124)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    width: 2.755,
    height: 15.915,
    transform: "translate(96.654 18.028)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M269.856,47.061a1.616,1.616,0,1,1-1.639,1.616,1.569,1.569,0,0,1,1.639-1.616m1.389,16.006h-2.778V51.8h2.778Z",
    transform: "translate(-165.986 -29.124)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M294.653,58.167l-1.412,1.639a4.852,4.852,0,0,1,1.3,3.347,4.3,4.3,0,0,1-2.778,4.212,3.708,3.708,0,0,1,2.778,3.643c0,3.188-3.119,4.736-6.124,4.736-3.894,0-6.171-1.958-6.057-5.169h2.755c-.114,1.549,1.548,2.482,3.3,2.482,1.548,0,3.232-.661,3.232-2.05,0-1.366-1.092-2.208-3.187-2.208-3.711,0-6.148-2.118-6.148-5.647,0-3.78,3.005-5.693,6.148-5.693a5.666,5.666,0,0,1,2.891.707l1.252-1.548Zm-9.563,4.986a3.113,3.113,0,0,0,3.37,3.1,3.118,3.118,0,1,0-3.37-3.1",
    transform: "translate(-174.709 -35.039)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M323.674,53.388A4.143,4.143,0,0,1,327.18,51.7c3.187,0,4.6,2.163,4.6,5.465v6.011H329V57.19c0-2.072-1.07-2.914-2.55-2.914a2.864,2.864,0,0,0-2.777,3.074v5.829H320.9V47.24h2.778Z",
    transform: "translate(-198.586 -29.234)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M361.4,68.163a4.683,4.683,0,0,0,3.005-1.047l1.776,1.753a7,7,0,0,1-4.827,1.821c-3.87,0-6.17-2.413-6.17-5.988a5.617,5.617,0,0,1,5.965-5.875c3.438,0,5.715,1.981,5.715,5.9,0,.342-.022.683-.045,1.047h-8.766c.182,1.389,1.366,2.391,3.347,2.391m-.16-6.876a3.023,3.023,0,0,0-3.141,2.186h6.056c-.182-1.457-1.3-2.186-2.914-2.186",
    transform: "translate(-219.804 -36.405)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M392.6,47.061a1.616,1.616,0,1,1-1.639,1.616,1.569,1.569,0,0,1,1.639-1.616m1.389,16.006h-2.777V51.8h2.777Z",
    transform: "translate(-241.943 -29.124)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M417.236,63.215h-2.6l-.183-1.548a3.93,3.93,0,0,1-3.62,1.867,5.576,5.576,0,0,1-5.783-5.943c0-3.871,2.436-5.875,5.715-5.875a4.613,4.613,0,0,1,3.688,1.8V47.3h2.778Zm-9.4-5.624a3.223,3.223,0,1,0,6.443,0,3.217,3.217,0,0,0-3.256-3.279,3.109,3.109,0,0,0-3.187,3.279",
    transform: "translate(-250.668 -29.272)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M447.73,61.1c-1.343,0-2.05.41-2.05,1.115,0,.729.707,1.138,2.095,1.23,2.118.114,4.8.638,4.8,3.575,0,1.981-1.639,3.688-4.827,3.688a6.57,6.57,0,0,1-5.191-2l1.366-1.981a5.58,5.58,0,0,0,3.962,1.57c1.025,0,1.936-.432,1.936-1.23,0-.751-.616-1.183-2.232-1.274-2.095-.183-4.645-.934-4.645-3.484,0-2.618,2.687-3.484,4.736-3.484a6.111,6.111,0,0,1,4.371,1.458l-1.548,1.822a3.88,3.88,0,0,0-2.777-1",
    transform: "translate(-273.879 -36.405)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M477.354,60.459a3.311,3.311,0,0,1,3.164-1.571,4.483,4.483,0,0,1,2.891,1.047l-1.252,2.413a2.983,2.983,0,0,0-2-.728,2.579,2.579,0,0,0-2.8,2.846v5.92h-2.778V59.162h2.573Z",
    transform: "translate(-293.691 -36.443)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M505.34,68.163a4.683,4.683,0,0,0,3.005-1.047l1.776,1.753a7,7,0,0,1-4.827,1.821c-3.87,0-6.17-2.413-6.17-5.988a5.617,5.617,0,0,1,5.965-5.875c3.438,0,5.715,1.981,5.715,5.9,0,.342-.022.683-.045,1.047h-8.766c.182,1.389,1.366,2.391,3.347,2.391m-.16-6.876a3.024,3.024,0,0,0-3.141,2.186H508.1c-.182-1.457-1.3-2.186-2.914-2.186",
    transform: "translate(-308.883 -36.405)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M546.167,58.167l-1.412,1.639a4.852,4.852,0,0,1,1.3,3.347,4.3,4.3,0,0,1-2.778,4.212,3.708,3.708,0,0,1,2.778,3.643c0,3.188-3.119,4.736-6.124,4.736-3.894,0-6.171-1.958-6.057-5.169h2.755c-.114,1.549,1.548,2.482,3.3,2.482,1.548,0,3.232-.661,3.232-2.05,0-1.366-1.092-2.208-3.187-2.208-3.711,0-6.148-2.118-6.148-5.647,0-3.78,3.005-5.693,6.148-5.693a5.666,5.666,0,0,1,2.891.707l1.252-1.548ZM536.6,63.153a3.113,3.113,0,0,0,3.37,3.1,3.118,3.118,0,1,0-3.37-3.1",
    transform: "translate(-330.358 -35.039)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M573.393,47.061a1.616,1.616,0,1,1-1.639,1.616,1.569,1.569,0,0,1,1.639-1.616m1.389,16.006H572V51.8h2.778Z",
    transform: "translate(-353.83 -29.124)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M597.442,64.786a5.886,5.886,0,1,1-5.92-5.9,5.735,5.735,0,0,1,5.92,5.9m-8.948,0a3.062,3.062,0,1,0,6.1,0,3.17,3.17,0,0,0-3.051-3.324,3.084,3.084,0,0,0-3.05,3.324",
    transform: "translate(-362.441 -36.443)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M178.27,123.377c0,4.713-2.891,7.127-6.9,7.127-3.825,0-7.081-2.3-7.081-7.127v-9.13h2.983v9.13c0,2.892,1.639,4.395,4.121,4.395s3.893-1.639,3.893-4.395v-9.13h2.983Z",
    transform: "translate(-101.671 -70.702)",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M212.107,121.484h3.1v2.391h-3.119v4.941c0,1.07.569,1.594,1.457,1.594a3.261,3.261,0,0,0,1.343-.341l.774,2.368a5.943,5.943,0,0,1-2.527.479c-2.322,0-3.8-1.366-3.8-4.1v-4.941h-2.095v-2.391h2.095v-2.936l2.778-.3Z",
    transform: "translate(-128.247 -73.18)",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M237.128,127.408a3.311,3.311,0,0,1,3.165-1.571,4.478,4.478,0,0,1,2.891,1.047l-1.252,2.413a2.988,2.988,0,0,0-2-.728,2.579,2.579,0,0,0-2.8,2.846v5.92H234.35V126.11h2.573Z",
    transform: "translate(-145.027 -77.874)",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M265.234,135.112a4.677,4.677,0,0,0,3.006-1.047l1.776,1.753a7,7,0,0,1-4.827,1.822c-3.871,0-6.17-2.414-6.17-5.988a5.617,5.617,0,0,1,5.965-5.875c3.438,0,5.715,1.981,5.715,5.9,0,.342-.022.684-.045,1.047h-8.766c.182,1.389,1.366,2.391,3.346,2.391m-.159-6.876a3.024,3.024,0,0,0-3.142,2.186h6.056c-.182-1.457-1.3-2.186-2.914-2.186",
    transform: "translate(-160.294 -77.837)",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M299.8,137.677c-3.256,0-5.965-1.935-5.965-5.9,0-4.008,2.71-5.943,5.965-5.943a5.33,5.33,0,0,1,4.053,1.662l-1.753,1.844a3.261,3.261,0,0,0-2.254-.887,3.145,3.145,0,0,0-3.233,3.324,3.021,3.021,0,0,0,3.188,3.233,3.319,3.319,0,0,0,2.459-.933l1.867,1.821a5.775,5.775,0,0,1-4.326,1.776",
    transform: "translate(-181.842 -77.875)",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M328.693,120.335a4.145,4.145,0,0,1,3.506-1.684c3.188,0,4.6,2.163,4.6,5.464v6.011h-2.778v-5.988c0-2.072-1.07-2.914-2.55-2.914a2.864,2.864,0,0,0-2.777,3.073v5.829h-2.778V114.187h2.778Z",
    transform: "translate(-201.692 -70.665)",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M364.235,121.484h3.1v2.391h-3.119v4.941c0,1.07.569,1.594,1.457,1.594a3.261,3.261,0,0,0,1.343-.341l.774,2.368a5.943,5.943,0,0,1-2.527.479c-2.322,0-3.8-1.366-3.8-4.1v-4.941h-2.095v-2.391h2.095v-2.936l2.778-.3Z",
    transform: "translate(-222.391 -73.18)",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 9.526,
    height: 9.526,
    transform: "translate(0 14.682)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 9.526,
    height: 9.526,
    transform: "translate(14.682 14.682)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 9.574,
    height: 9.574,
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    width: 9.526,
    height: 9.526,
    transform: "translate(14.682)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M24.208,77.039H0v7.225c0,13.911,11.191,22.872,24.09,22.872h.119Z",
    transform: "translate(0 -47.676)",
    fill: "#d10a10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M63.513,29.364h9.222c.091,0,1.066,0,1.156.006s.154-.006.232-.006A8.072,8.072,0,0,1,82.2,37.436,7.863,7.863,0,0,1,74.261,45.3l6.926,7.054a23.556,23.556,0,0,0,6.419-16.63V0Z",
    transform: "translate(-39.305 -0.001)",
    fill: "#f28d00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVru);
export default __webpack_public_path__ + "static/media/vru.8ceeb12bcf9c9cbb7858413d14fc7145.svg";
export { ForwardRef as ReactComponent };